<template>                    
    
    <v-layout row>
        <v-flex xs5>
            <v-select                        
                label="Auswahl Warengruppen"
                autocomplete
                v-bind:async-loading="loading"
                dark
                multiple
                cache-items
                chips
                required
                v-bind:items="warengruppen"     
                item-text="name"
                item-value="id"
                return-object
                v-bind:search-input.sync="search"
                v-model="mk.warengruppen"></v-select>
        </v-flex>

        <v-flex xs6 offset-xs1> 
            <v-layout row wrap>
                <v-flex xs6 v-for="(warengruppe,index) in mk.warengruppen" v-bind:key="index">
                    <p><strong> {{ warengruppe.name }} </strong></p>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {           
                    
            search: null,            
        };
    },
    watch: {
      search (val) {
        val && this.querySelections(val)
      }
    },
    /*created: function(){
        this.$store.dispatch('setWarengruppen')
    },*/
    computed: {
        warengruppen: function() {
            
            return this.$store.getters.warengruppen
        },
        mk: function() {
            return this.$store.getters.marke
        },
        loading: function() {
            return this.$store.getters.loading
        }
    },
    methods: {

        querySelections (v) {
            //this.loading = true               
            this.mk.warengruppen = this.types.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })
            //this.loading = false
        
        },
              
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// warengruppenSelect.vue?5bf7c5ff